<template>
    <li class="item" :class="{ 'tile-item': !inModal }">
        <div><b>Сообщение №{{leasing.notification_number}} от {{dateParser(leasing.notification_date)}}</b></div>
        <div class="item__status">
            <b>Статус:</b>
            <span :class="{ green: leasing.contract_status, red: !parseInt(leasing.contract_status) }">{{leasing.contract_status | getStatus}}</span>
            <span v-if="leasing.contract_cancel_reason">({{ leasing.contract_cancel_reason }})</span>
        </div>
        <div class="item__lessor">
            <b v-if="!leasing.lessors.length > 1">Лизингодатель:</b>
            <b v-else>Лизингодатели:</b>
            <span class="cursor-help" :title="lawDescr" v-if="leasing.lessors.length === 0">Сведения скрыты в соответствии с требованиями постановления Правительства РФ от 12.01.2018 г. №5</span>
            <participant v-else-if="leasing.lessors.length === 1" :participant="leasing.lessors[0]" />
            <ul v-else>
                <li v-for="(l, i) in leasing.lessors" :key="i">
                    <participant :participant="l" />
                </li>
            </ul>
        </div>
        <div class="item__lessees">
            <b v-if="!leasing.lessees.length > 1">Лизингополучатель:</b>
            <b v-else>Лизингополучатели:</b>
            <span class="cursor-help" :title="lawDescr" v-if="leasing.lessees.length === 0">Сведения скрыты в соответствии с требованиями постановления Правительства РФ от 12.01.2018 г. №5</span>
            <participant v-else-if="leasing.lessees.length === 1" :participant="leasing.lessees[0]" />
            <ul v-else>
                <li v-for="(l, i) in leasing.lessees" :key="i">
                    <participant :participant="l" />
                </li>
            </ul>
        </div>
        <div class="item__period">
            <b>Срок финансовой аренды:</b>
            <span>
                {{dateParser(leasing.leasing_interval_start)}} - {{dateParser(leasing.leasing_interval_end)}}
            </span>
        </div>
        <div v-if="inModal" class="item__details">
            <div v-if="leasing.contract_number">
                <b>Договор:</b>
                <span>{{leasing.contract_number}}</span>
            </div>
            <div v-if="leasing.subjects.length > 0">
                <b>Предметы финансовой аренды:</b>
                <table class="subjects-table">
                    <thead>
                        <tr>
                            <th>Идентификатор</th>
                            <th>Классификация</th>
                            <th>Описание</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, i) in leasing.subjects" :key="i">
                            <td>{{s.SubjectId ? s.SubjectId : ''}}</td>
                            <td>{{s.ClassifierName ? s.ClassifierName : ''}}</td>
                            <td>{{s.Description ? s.Description : ''}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </li>
</template>
     
<script>
import leasingParticipant from '@/components/card/zalogLeasing/leasing/leasingParticipant.vue'

export default {
    props: {
        leasing: Object,
        inModal: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        lawDescr: 'В случае если в отношении физических лиц, являющихся индивидуальными предпринимателями, и юридических лиц иностранными государствами, государственными объединениями и (или) союзами и (или) государственными (межгосударственными) учреждениями иностранных государств или государственных объединений и (или) союзов введены меры ограничительного характера, в отношении таких лиц не подлежат размещению в информационно-телекоммуникационной сети "Интернет" сведения, предусмотренные подпунктами "л.2", "н.1" - "н.3" и "о" пункта 7 статьи 7.1 Федерального закона "О государственной регистрации юридических лиц и индивидуальных предпринимателей" (за исключением сведений, предусмотренных законодательством Российской Федерации о несостоятельности (банкротстве), законодательством Российской Федерации об исполнительном производстве, законодательством Российской Федерации о саморегулируемых организациях), при условии соблюдения требований, предусмотренных абзацами вторым - шестым пункта 2.1 статьи 7.1 указанного Федерального закона.'
    }),
    components: {
        participant: leasingParticipant
    },
    filters: {
        getStatus(value) {
            switch(parseInt(value)) {
                case 1:
                    return 'Действующий'
                case 0:
                    return 'Завершён'
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.item
    display: flex
    flex-direction: column
    gap:  4px
    padding: 15px 0
    border-bottom: 1px solid #ddd
    &__details
        display: flex
        flex-direction: column
        gap:  10px
    .cursor-help
        cursor: help
    .green
        color: #27ae60
    .red
        color: #e74c3c
    .subjects-table
        margin-top: 12px
        @include lic-table
        margin-bottom: 0
        tr
            th
                font-size: 16px
                &:not(:last-child)
                    width: 30%
            td
                &:not(:last-child)
                    width: 30%
                font-size: 16px
                text-align: left !important
.tile-item
    font-size: 13px
    &:nth-child(1)
        padding-top: 0
</style>